import { type iEnvironment } from "@atmgrupomaggioli/mlb-typehub-atm";

const URL_API_ROOT = 'https://pmcloudserver.atm-maggioli.es';

export const environment: iEnvironment = 
{  general: {
    PRODUCTION: true,
    ENVIRONMENT: 'Production',
    DOMAIN: 'https://citaprevia.eadministracion.es',
  },
  backends: {
    URL_API_ROOT: URL_API_ROOT,
    URL_API_COMUN: 'https://backendcitaprevia.atm-maggioli.es',
  },
  frontends: {
    URL_ATMPANEL: 'https://aplicaciones.atm-maggioli.es',
  },
  additional: {
    LOGO_ATM_MAGGIOLI: 'assets/images/logo_atm_maggioli_blanco.png',
    VERSION: '1.2',
  }
};